const urls = {
    1: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    2: "https://www.youtube.com/watch?v=_muVge9sJP4",
    3: "https://www.youtube.com/watch?v=VIj2lcOl5As",
    4: "https://www.youtube.com/watch?v=GNvKExgbjIA",
    5: "https://www.youtube.com/watch?v=vu_YGgZQ9DE",
    6: "https://www.youtube.com/watch?v=maTOE0E984U",
    7: "https://www.youtube.com/watch?v=NKtiX0mmVjI&feature=youtu.be",
    8: "http://www.laclef.online/le-sceau/",
    9: "https://fr.wikipedia.org/wiki/Comic_Sans",
    10: "https://www.facebook.com/faneliart/",
    11: "https://www.youtube.com/watch?v=1paueaTWFRE",
    12: "https://www.cidehom.com/quark-184.html",
    13: "https://www.youtube.com/watch?v=G1IbRujko-A",
    14: "https://fr.wikipedia.org/wiki/Gemme",
    15: "https://www.youtube.com/watch?v=BHkhIjG0DKc",
    16: "https://fr.wikipedia.org/wiki/Dragon_(constellation)",
    17: "https://fr.wikipedia.org/wiki/Chiffre_de_Cornelius_Agrippa",
    18: "https://www.cnrtl.fr/lexicographie/intersection",
    19: "https://www.youtube.com/watch?v=O2ulyJuvU3Q",
    20: "https://www.youtube.com/watch?v=XE6YaLtctcI",
    21: "https://fr.wikipedia.org/wiki/Renard",
    22: "https://www.youtube.com/watch?v=ytWz0qVvBZ0",
    23: "https://fr.wikipedia.org/wiki/Mati%C3%A8re_noire",
    24: "https://www.youtube.com/watch?v=LwkmqvmcyEw&t=5s",
    25: "http://www.faneliart.fr/",
    26: "https://www.youtube.com/watch?v=y6120QOlsfU",
    27: "https://www.youtube.com/watch?v=ZZ5LpwO-An4",
    28: "https://www.youtube.com/watch?v=pibSbfAPE-g",
    29: "https://www.youtube.com/watch?v=O0MFVwALWsg",
    30: "https://www.facebook.com/enigmelaclef/",
    31: "https://www.youtube.com/watch?v=dOJwGl3yLMU",
    32: "https://www.youtube.com/watch?v=-Fl3ZwERMgE",
    33: "https://www.youtube.com/watch?v=4GtyMeEcPPE",
    34: "https://www.instagram.com/fanelia_art",
    35: "https://fr.wikipedia.org/wiki/Schisme",
    36: "https://www.youtube.com/watch?v=MNRFOiqksNI",
    37: "https://www.youtube.com/watch?v=6H2FRxvsd2M",
    38: "https://www.youtube.com/watch?v=UjpbQ1OWMPE",
    39: "https://www.youtube.com/watch?v=wN4Rbc6HSPY",
    40: "https://www.youtube.com/watch?v=inStPQaAgdM",
    41: "https://www.youtube.com/watch?v=NUYvbT6vTPs",
    42: "https://www.youtube.com/watch?v=uwmeH6Rnj2E",
    43: "https://www.youtube.com/watch?v=zxbufWzX1NA",
    44: "https://www.youtube.com/watch?v=i8ju_10NkGY",
    45: "https://www.youtube.com/watch?v=aTBlKRzNf74",
    46: "https://www.youtube.com/watch?v=Rk_sAHh9s08",
    47: "https://fr.wikipedia.org/wiki/Couleur_compl%C3%A9mentaire",
    48: "https://fr.wikipedia.org/wiki/Filicophyta",
    49: "https://www.youtube.com/watch?v=QH2-TGUlwu4",
    50: "https://fr.wikipedia.org/wiki/Arc_de_m%C3%A9ridien",
    51: "https://www.sncf.com/fr",
    52: "https://fr.wikipedia.org/wiki/Saint-P%C3%A9tersbourg",
    53: "https://www.youtube.com/watch?v=gRcj6CAhe7s",
    54: "https://fr.wikipedia.org/wiki/Blason_(h%C3%A9raldique)",
    55: "https://www.youtube.com/watch?v=PDHCLjuOzXY",
    56: "https://www.youtube.com/watch?v=f2qvcZ7u0tA",
    57: "https://www.youtube.com/watch?v=vCEvCXuglqo",
    58: "https://www.youtube.com/watch?v=JWo3nMaLzCI",
    59: "https://www.youtube.com/watch?v=-OKzWSehiMs",
    60: "https://www.youtube.com/watch?v=5-sfG8BV8wU",
    61: "https://www.youtube.com/",
    62: "https://www.youtube.com/watch?v=mvwd13F_1Gs",
    63: "https://fr.wikipedia.org/wiki/Cinq_%C3%A9l%C3%A9ments",
    64: "https://www.youtube.com/watch?v=E-p6l9nioNI&t=",
    65: "https://www.youtube.com/watch?v=V5M2WZiAy6k",
    66: "https://www.youtube.com/watch?v=ghKy8FRhs28",
    67: "https://www.youtube.com/watch?v=uE-1RPDqJAY&t=4s",
    68: "https://www.youtube.com/watch?v=VJxNv2m7qns",
    69: "https://www.youtube.com/watch?v=8tC32ZIYXlE",
    70: "https://www.youtube.com/watch?v=a1Y73sPHKxw",
    71: "https://www.youtube.com/watch?v=y8Kyi0WNg40",
    72: "https://fr.ulule.com/",
    73: "https://home.cern/fr",
    74: "https://www.youtube.com/watch?v=x2QBDQXn3iU",
    75: "https://www.youtube.com/watch?v=Z-XrwCvRnko",
    76: "https://www.youtube.com/watch?v=Bm5f_glnQ5M",
    77: "https://www.youtube.com/watch?v=C2n212OP1cQ",
    78: "https://www.youtube.com/watch?v=bpxtuUQ28UM",
    79: "https://www.youtube.com/watch?v=bWcASV2sey0",
    80: "https://www.youtube.com/watch?v=wo9PMqwx4ZQ",
    81: "https://fr.wikipedia.org/wiki/Tableau_p%C3%A9riodique_des_%C3%A9l%C3%A9ments#/media/Fichier:Tableau_p%C3%A9riodique_des_%C3%A9l%C3%A9ments.svg",
    82: "https://www.youtube.com/watch?v=rpWrtXyEAN0",
    83: "https://fr.wikipedia.org/wiki/Tachyon",
    84: "https://www.youtube.com/watch?v=eYp9d72g0CI",
    85: "https://color.adobe.com/fr/create",
    86: "https://www.youtube.com/watch?v=otCpCn0l4Wo",
    87: "https://www.youtube.com/watch?v=qbIet2sM-JA",
    88: "https://www.youtube.com/watch?v=Rn66oPyuFcQ",
    89: "http://www.laclef.online/univers/",
    90: "https://www.youtube.com/watch?v=ajbt3-YyE4s",
    91: "https://fr.wikipedia.org/wiki/Tytonidae",
    92: "https://www.youtube.com/watch?v=wRnSnfiUI54",
    93: "https://www.youtube.com/watch?v=jScuYd3_xdQ",
    94: "https://www.youtube.com/watch?v=g8fmbRoxkzM",
    95: "https://www.youtube.com/watch?v=BG6EtT-mReM",
    96: "https://www.youtube.com/watch?v=MqdM8pE1huc",
    97: "https://fr.wikipedia.org/wiki/Gluon",
    98: "https://www.scifi-universe.com/",
    99: "https://www.youtube.com/watch?v=kxopViU98Xo",
    100: "https://www.youtube.com/watch?v=OMIrzkQoyKU"
}

export default urls;


